// extracted by mini-css-extract-plugin
export var anchorForm = "paper-module--anchorForm--87fb4";
export var colform = "paper-module--colform--c0ef9";
export var imageportada = "paper-module--imageportada--e825a";
export var linkback = "paper-module--linkback--60084";
export var topics = "paper-module--topics--af060";
export var topictag = "paper-module--topictag--3f0ed";